<template>
  <div class="con-main">
    <div class="bzlm-nav">
      <div class="bzlm-nav-list" @click="comeback">返回上级</div>
      <div class="bzlm-nav-list" @click="bmgl">页面预览</div>
      <div class="bzlm-nav-list" @click="bqxq">本期详情</div>
      <div class="bzlm-nav-list2">选择期数</div>
      <div class="bzlm-nav-list2 bzlm-nav-list3">
        <el-cascader
        filterable
          placeholder="请选择期数"
          size="small"
          v-model="qsvalue"
          :options="qsoptions"
          @change="handleChange"
        />
      </div>

      <div class="bzlm-nav-sxq">
        <div class="bzlm-nav-sxq-l" @click="shangyiqi">上一期</div>
        <div class="bzlm-nav-sxq-l" @click="xiayiqi">下一期</div>
      </div>
    </div>
    <div class="bzlm">
      <div class="bzlm-banmian">
        <div
          class="bzlm-banmian-list"
          v-for="(item, key) in bminfolist"
          :key="key"
        >
          <div class="bzlm-banmian-list-img">
            <el-image
              style="width: 100%; height: 380px"
              :src="`${proxy.$imgurl}${item.bmurl}`"
              :preview-src-list="srcList"
              :initial-index="key"
            />
          </div>
          <div class="bzlm-banmian-list-title">
            第{{ item.bm }}页
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, getCurrentInstance, ref, defineProps } from "vue";
const { proxy } = getCurrentInstance();
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();
// 父组件传递值
const props = defineProps({
  lanmuobj: {
    type: Object,
  },
});
// 根据栏目生成需要跳转的路径前缀
let urlqz = ref("");
switch (router.currentRoute.value.query.navid) {
  case "1":
    urlqz.value = "/jyyj";
    break;
  case "2":
    urlqz.value = "/kjts";
    break;
  case "3":
    urlqz.value = "/jkkp";
    break;
  case "4":
    urlqz.value = "/szyt";
    break;
  case "5":
    urlqz.value = "/myrh";
    break;
  case "6":
    urlqz.value = "/xljj";
    break;
  case "7":
    urlqz.value = "/xxfz";
    break;
  default:
    urlqz.value = "";
    break;
}

// 当前期数索引
let dqqsindex = ref(0);
// 类型
let contype = store.state.contype;
// 全部期数
let allqishuList = reactive([]);
// 选择期数
let qsvalue = ref("");
let qsoptions = reactive([]);
// 本期详情
let bqxqobj = reactive({});
// 版面信息
let bminfolist = reactive([]);
// 页面预览
let srcList=reactive([])
// 获取全部期数
const getqsall = () => {
  get("/api/NewsPaper/GetAllQishu", {
    type: contype.filter((e) => {
      return e.name === "期刊";
    })[0].value,
    id: router.currentRoute.value.query.bzid,
  }).then((res) => {
    // console.log(res);
    // 保存全部期数
    allqishuList.push(...res.data);
    // 获取最新一期内容
    // getbqxq(allqishuList[dqqsindex.value].Id);
    // 获取链接期数id
    getbqxq(router.currentRoute.value.query.id);
    // 根据当前期数id找出其在全部期数中的索引
    allqishuList.forEach((e,i)=>{
      if(e.Id===router.currentRoute.value.query.id){
        dqqsindex.value=i
      }
    })
    // 渲染期数下拉框 筛选出年份 通过年份生成数组
    // console.log(allqishuList);
    let tempval = ""; //临时年份
    let yearsz = []; //年份数组
    allqishuList.forEach((e) => {
      //筛选出数组中年份
      if (tempval == "") {
        tempval = e.year;
        yearsz.push(e.year);
      } else {
        if (tempval != e.year) {
          tempval = e.year;
          yearsz.push(e.year);
        } else {
          return true;
        }
      }
    });
    qsoptions.length = 0; //重置select
    yearsz.forEach((e, i) => {
      //通过年份生成数组
      qsoptions.push({
        value: e,
        label: `${e}年`,
        children: [],
      });
      let childrenval = [];
      allqishuList.forEach((ele) => {
        if (e == ele.year) {
          // 存在小期数添加，不存在为""不添加
          if(ele.smallqs!=""){
            childrenval.push({
              value: ele.Id,
              label: `第${ele.qs}-${ele.smallqs}期`,
            });
          }else{
            childrenval.push({
              value: ele.Id,
              label: `第${ele.qs}期`,
            });
          }
        }
      });
      qsoptions[i].children = childrenval;
    });
  });
};
getqsall();

// 获取本期详情
const getbqxq = (qsid) => {
  get("/api/NewsPaper/GetQishuDet", {
    id: qsid,
  }).then((res) => {
    // console.log(res.data);
    // 清空
    Object.keys(bqxqobj).map((key) => {
      delete bqxqobj[key];
    });
    Object.assign(bqxqobj, res.data);
    bminfolist.length = 0;
    bminfolist.push(...JSON.parse(bqxqobj.bmjson));
    srcList.length=0
    bminfolist.forEach(e=>{
      srcList.push(proxy.$imgurl+e.bmurl)
    })
    // console.log(bminfolist)
    
});
};

// 点击期数
const viewxq = (value) => {
  router.push({
    path: urlqz.value+"/index",
    query: {
      navid: router.currentRoute.value.query.navid, //栏目id
      id: router.currentRoute.value.query.id, //当前期数id
      bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
      bmidx: value + 1,
    },
  });
};

// 选择期数
const handleChange = (value) => {
  router.push({
    path: urlqz.value+"/bmgl",
    query: {
      navid: router.currentRoute.value.query.navid, //栏目id
      id: value[1], //当前期数id
      bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
    },
  });
};

// 上一期
const shangyiqi = () => {
  if (allqishuList[dqqsindex.value - 1]) {
    router.push({
      path: urlqz.value+"/bmgl",
      query: {
        navid: router.currentRoute.value.query.navid, //栏目id
        id: allqishuList[dqqsindex.value - 1].Id, //当前期数id
        bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
      },
    });
  } else {
    ElMessage({
      message: "已经是第一期了",
      type: "info",
    });
    return false;
  }
};

// 下一期
const xiayiqi = () => {
  if (allqishuList[dqqsindex.value + 1]) {
    router.push({
      path: urlqz.value+"/bmgl",
      query: {
        navid: router.currentRoute.value.query.navid, //栏目id
        id: allqishuList[dqqsindex.value + 1].Id, //当前期数id
        bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
      },
    });
  } else {
    ElMessage({
      message: "已经是最新一期了",
      type: "info",
    });
    return false;
  }
};

// 跳转
const comeback = () => {
  router.push({
    path: urlqz.value+"/list",
    query: {
      idx: store.state.navindex,
      dflid: router.currentRoute.value.query.navid, //大分类id,
    },
  });
};
// 版面概览
const bmgl = () => {
  router.push({
    path: urlqz.value+"/bmgl",
    query: {
      navid: router.currentRoute.value.query.navid, //栏目id
      id: router.currentRoute.value.query.id, //当前期数id
      bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
    },
  });
};
// 本期详情
const bqxq = () => {
  router.push({
    path: urlqz.value+"/index",
    query: {
      navid: router.currentRoute.value.query.navid, //栏目id
      id: router.currentRoute.value.query.id, //当前期数id
      bzid: router.currentRoute.value.query.bzid, //报纸id  用于获取全部期数
    },
  });
};
</script>

<style scoped>
::v-deep .select-trigger {
  width: 120px;
}
.main {
  background: #fff;
}
.con-main {
  width: 1200px;
  margin: auto;
  margin-bottom: 30px;
}
.con-main:after {
  content: "";
  display: table;
  clear: both;
}
.jkrb-banner {
  width: 100%;
  height: 163px;
  text-align: center;
}
.bzlm {
  margin-top: 20px;
}
.bzlm-nav {
  width: 100%;
  height: 40px;
  background: #fafafa;
  border-top: 5px solid #ddd;
  border-bottom: 5px solid #ddd;
  margin-top: 20px;
}
.bzlm-nav-list {
  float: left;
  margin: 10px 30px 0 30px;
  cursor: pointer;
}
.bzlm-nav-list:hover {
  color: #2fadc6;
}
.bzlm-nav-list2 {
  float: left;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 30px;
}
.bzlm-nav-list3 {
  margin-left: 10px;
}
.bzlm-nav-list2-span {
  font-size: 14px;
}
.bzlm-nav-sxq {
  float: right;
  margin-right: 30px;
  width: 120px;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.bzlm-nav-sxq-l {
  cursor: pointer;
}
.bzlm:after {
  content: "";
  display: table;
  clear: both;
}

.bzlm-banmian {
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  height: auto;
  border: 1px solid #ccc;
  background: #fafafa;
}
.bzlm-banmian::after {
  content: "";
  display: table;
  clear: both;
}
.bzlm-banmian-list {
  float: left;
  width: 24%;
  height: auto;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin: 0.5%;
  cursor: pointer;
}
.bzlm-banmian-list:hover {
  border: 1px solid #333;
}
.bzlm-banmian-list-img {
  width: 100%;
  height: 380px;
}
.bzlm-banmian-list-title {
  width: 100%;
  height: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  font-size: 14px;
}
</style>
